import { ExternalMention } from '@connect-x-app/shared-domain-models';
import { API_FACTORY } from '@connect-x-app/shared-utils';

import { HttpClient } from '../utils';

export const getExternalMentions = (): Promise<ExternalMention[]> => {
  return HttpClient.get(API_FACTORY.v1('mentions/external-options'), { limit: -1 });
};
